module.exports = __webpack_public_path__ + "0362f14262b9f1fd093122c8462297fb.png";